import { TFunction } from 'i18next';
import { StepConfigItem } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import PersonalInfoStep from './new_components/PersonalInfo';
import PhoneNumberInputComponentStep from './new_components/PhoneNumberInputComponent';
import VehicleSearchStep from './new_components/VehicleSearch';
import VerifyOTPComponentStep from './new_components/VerifyOTPComponent';
import VehicleInfoStep from './new_components/VehicleInfo';
import VehicleOptionStep from './new_components/VehicleOption';
import VehicleConditionsStep from './new_components/VehicleConditions';
import ResultStep from './new_components/Result';

export const tradeInStepConfig1 = (t: TFunction): StepConfigItem[] => {
  return [
    {
      step1: {
        component: <VehicleSearchStep callStepSpecificAction={true} />,
        step: 0,
        pageName: 'Vehicle Search',
        isHeaderHidden: true,
        footerNavigationProps: {
          nextNavigation: false,
        },
      },
    },
    {
      step2: {
        component: <PersonalInfoStep callStepSpecificAction={true} />,
        message: t('stepperFormTradeIn.note4'),
        step: 1,
        pageName: 'Personal Information',
        footerNavigationProps: {
          buttonTitle: t('stepperFormTradeIn.seeEstimatedTradeInVal'),
          backNavigation: false,
        },
      },
    },
    {
      step3: {
        component: <PhoneNumberInputComponentStep callStepSpecificAction={true} />,
        step: 2,
        pageName: 'Phone Verification',
        footerNavigationProps: {
          backNavigation: false,
          buttonTitle: t('stepperFormTradeIn.confirmPhoneButtonLabel'),
        },
      },
    },
    {
      step4: {
        component: <VerifyOTPComponentStep callStepSpecificAction={false} />,
        pageName: 'Phone Verification',
        step: 3,
      },
    },
  ];
};

export const tradeInStepConfig2 = (t: TFunction): StepConfigItem[] => {
  return [
    {
      step1: {
        component: <PersonalInfoStep callStepSpecificAction={true} />,
        message: t('stepperFormTradeIn.note4'),

        step: 0,
        pageName: 'Personal Information',
        footerNavigationProps: {
          buttonTitle: t('stepperFormTradeIn.seeEstimatedTradeInVal'),
          backNavigation: false,
        },
      },
    },
    {
      step2: {
        component: <PhoneNumberInputComponentStep callStepSpecificAction={true} />,
        step: 1,
        pageName: 'Phone Verification',
        footerNavigationProps: {
          backNavigation: false,
          buttonTitle: t('stepperFormTradeIn.confirmPhoneButtonLabel'),
        },
      },
    },
    {
      step3: {
        component: <VerifyOTPComponentStep callStepSpecificAction={false} />,
        pageName: 'Phone Verification',
        step: 2,
      },
    },
  ];
};

export const tradeInStepConfig3 = (t: TFunction): StepConfigItem[] => {
  return [
    {
      step1: {
        component: <VehicleInfoStep callStepSpecificAction={true} />,
        message: t('stepperFormTradeIn.note4'),
        step: 0,
        pageName: 'Vehicle Information',
        footerNavigationProps: {
          buttonTitle: t('stepperFormTradeIn.nextVehicleOptions'),
          backNavigation: false,
          fullWidth: true,
        },
      },
    },
    {
      step2: {
        component: <VehicleOptionStep callStepSpecificAction={true} />,
        step: 1,
        pageName: 'Vehicle Options',
        footerNavigationProps: {
          backNavigation: true,
          buttonTitle: t('stepperFormTradeIn.nextVehicleCondition'),
        },
      },
    },
    {
      step3: {
        component: <VehicleConditionsStep callStepSpecificAction={true} />,
        step: 2,
        pageName: 'Vehicle Condition',
        footerNavigationProps: {
          backNavigation: true,
          buttonTitle: t('stepperFormTradeIn.next'),
        },
      },
    },
    // {
    //   step4: {
    //     component: <VehicleConditionsPage2Step callStepSpecificAction={true} />,
    //     step: 3,
    //     footerNavigationProps: {
    //       backNavigation: true,
    //       buttonTitle: t('stepperFormTradeIn.nextPersonalInfo'),
    //     },
    //   },
    // },
    {
      step5: {
        component: <PersonalInfoStep callStepSpecificAction={true} />,
        message: t('stepperFormTradeIn.note4'),
        step: 3,
        pageName: 'Personal Information',
        footerNavigationProps: {
          buttonTitle: t('stepperFormTradeIn.seeEstimatedTradeInVal'),
          backNavigation: true,
        },
      },
    },
    // {
    //   step6: {
    //     component: <PhoneNumberInputComponentStep callStepSpecificAction={true} />,
    //     step: 4,
    //     footerNavigationProps: {
    //       backNavigation: false,
    //       buttonTitle: t('stepperFormTradeIn.confirmPhoneButtonLabel'),
    //     },
    //   },
    // },
    {
      step7: {
        component: <VerifyOTPComponentStep callStepSpecificAction={true} />,
        pageName: 'Phone Verification',
        step: 4,
      },
    },
    {
      step8: {
        component: <ResultStep callStepSpecificAction={false} />,
        step: 5,
        pageName: 'Estimated Trade-In Value',
        isHeaderHidden: true,
        footerNavigationProps: {
          nextNavigation: false,
          backNavigation: false,
          submitButtonVisibility: false,
        },
      },
    },
  ];
};

export const tradeInStepConfig4 = (t: TFunction): StepConfigItem[] => {
  return [
    {
      step1: {
        component: <VehicleSearchStep callStepSpecificAction={true} />,
        step: 0,
        pageName: 'Vehicle Search',
        isHeaderHidden: true,
        footerNavigationProps: {
          nextNavigation: false,
        },
      },
    },
    {
      step2: {
        component: <VehicleInfoStep callStepSpecificAction={true} />,
        message: t('stepperFormTradeIn.note4'),
        step: 1,
        pageName: 'Vehicle Information',
        footerNavigationProps: {
          buttonTitle: t('stepperFormTradeIn.nextVehicleOptions'),
          backNavigation: false,
          fullWidth: true,
        },
      },
    },
    {
      step3: {
        component: <VehicleOptionStep callStepSpecificAction={true} />,
        step: 2,
        pageName: 'Vehicle Options',
        footerNavigationProps: {
          backNavigation: true,
          buttonTitle: t('stepperFormTradeIn.nextVehicleCondition'),
        },
      },
    },
    {
      step4: {
        component: <VehicleConditionsStep callStepSpecificAction={true} />,
        step: 3,
        pageName: 'Vehicle Condition',
        footerNavigationProps: {
          backNavigation: true,
          buttonTitle: t('stepperFormTradeIn.next'),
        },
      },
    },
    // {
    //   step5: {
    //     component: <VehicleConditionsPage2Step callStepSpecificAction={true} />,
    //     step: 4,
    //     footerNavigationProps: {
    //       backNavigation: false,
    //       buttonTitle: t('stepperFormTradeIn.nextPersonalInfo'),
    //     },
    //   },
    // },
    {
      step5: {
        component: <PersonalInfoStep callStepSpecificAction={true} />,
        message: t('stepperFormTradeIn.note4'),
        step: 4,
        pageName: 'Personal Information',
        footerNavigationProps: {
          buttonTitle: t('stepperFormTradeIn.seeEstimatedTradeInVal'),
          backNavigation: true,
        },
      },
    },
    // {
    //   step6: {
    //     component: <PhoneNumberInputComponentStep callStepSpecificAction={true} />,
    //     step: 5,
    //     footerNavigationProps: {
    //       backNavigation: false,
    //       buttonTitle: t('stepperFormTradeIn.confirmPhoneButtonLabel'),
    //     },
    //   },
    // },
    {
      step7: {
        component: <VerifyOTPComponentStep callStepSpecificAction={true} />,
        step: 5,
        pageName: 'Phone Verification',
        footerNavigationProps: {
          buttonTitle: t('stepperForm.submit'),
        },
      },
    },
    {
      step8: {
        component: <ResultStep callStepSpecificAction={false} />,
        step: 6,
        pageName: 'Estimated Trade-In Value',
        isHeaderHidden: true,
        footerNavigationProps: {
          nextNavigation: false,
          backNavigation: false,
          submitButtonVisibility: false,
        },
      },
    },
  ];
};
